import React, { FunctionComponent } from 'react'
import { Form, Select } from 'antd'
import { Agencies, Vehicle } from 'server'
import { useLoaderData, useMatch } from '@tanstack/react-router'

interface IProps {
  onChange: any
  vehicles: Vehicle[]
}

const AgencySelect: FunctionComponent<any> = (props: IProps) => {

  const { vehicles } = props

  const match = useMatch({ strict: false })
  const { agencies } = useLoaderData({
    from: match.routeId ?? '/'
  })

  // Unique agencies from vehicles
  const agencyIds = vehicles.map((vehicle: Vehicle) => vehicle.agency_id)
  const uniqueAgencyIds = [...new Set(agencyIds)]

  const filteredAgencies = agencies.filter((agency: Agencies) => {
    return uniqueAgencyIds.includes(agency.id)
  })

  const handleFilter = (input: any, option: any) =>
    option.children.toLowerCase().search(input.toLowerCase()) !== -1

  const renderAgency = (agency: Agencies) => {
    return (
      <Select.Option key={agency.id} value={agency.id}>
        {agency?.friendly_name || agency?.name}
      </Select.Option>
    )
  }

  return (
    <Form.Item name={'agency_id'} style={{ margin: 0 }}>
      <Select
        placeholder={'Search by Agency'}
        onChange={props?.onChange}
        allowClear={true}
        filterOption={handleFilter}
      >
        {filteredAgencies.map(renderAgency)}
      </Select>
    </Form.Item>
  )
}

export default AgencySelect
